// src/store/thunks/user/getMeThunk.ts
import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';

export const getMeThunk = createAppAsyncThunk(
  "user/getMe",
  async(id: string, { extra: { userService } }) => await userService.getMe(id)
);
